/**
 * @file picking-confirm-text.ts
 * @description Тексты подтверждений опасных действий над заданием на сборку
 * (выделены из `PickingTaskActions` в phase19.23).
 *
 * Одно действие вызывается из двух мест — меню задания и кнопки в полосе
 * «строки потерялись», — а формулировка обязана быть одна: менеджер должен
 * прочитать одинаковое обещание, откуда бы ни нажал.
 *
 * Реестр вместо каскада `if`: новая операция = запись (OCP).
 */

/** Что подтверждаем. */
export type PickingConfirmKind = "release" | "return" | "rebuild" | "cancel";

interface ConfirmText {
  title: string;
  description: string;
  /** Подпись подтверждающей кнопки. */
  action: string;
}

export const PICKING_CONFIRM_TEXT: Record<PickingConfirmKind, ConfirmText> = {
  release: {
    title: "Освободить задание?",
    description:
      "Исполнитель снимется, задание вернётся в очередь со статусом «Новое». " +
      "Собранные количества сохранятся, отметки недостачи будут сняты — " +
      "кладовщик пройдёт задание заново.",
    action: "Освободить",
  },
  return: {
    title: "Вернуть задание в очередь?",
    description:
      "Задание снова станет «Новым», и его сможет взять любой кладовщик. " +
      "Собранные количества сохранятся, отметки недостачи будут сняты — " +
      "кладовщик пройдёт задание заново.",
    action: "Вернуть в очередь",
  },
  rebuild: {
    title: "Пересобрать задание?",
    description:
      "Строки задания будут пересобраны из текущих резервов заказа; " +
      "собранные количества сохранятся.",
    action: "Пересобрать",
  },
  cancel: {
    title: "Отменить задание?",
    description:
      "Сборка остановится, задание получит статус «Отменено». Заказ останется " +
      "на своей стадии; вернуть задание в очередь можно будет той же кнопкой.",
    action: "Отменить задание",
  },
};
